// Load modules

var Stringify = require('./stringify');
var Parse = require('./parse');


// Declare internals

var internals = {};


module.exports = {
    stringify: Stringify,
    parse: Parse
};



/*****************
 ** WEBPACK FOOTER
 ** /~/react-router/~/qs/lib/index.js
 ** module id = 508
 ** module chunks = 9
 **/